import { ContentManagerRequest } from "../../api/ContentManagerRequest";
import { MilestonesRequest } from "../../api/MilestonesRequest";
import { MILESTONES_FETCH_PROGRESS, MILESTONES_RESET_PROGRESS, MILESTONES_SET_INSTANCE_NAME, MILESTONES_SET_INTERACIONES } from "../types/milestonesTypes";

export const getProgress = (payload: any) => (dispatch: any) => {
    return new Promise(async (resolve: any, reject:any) => {
        try{
            const resp = await MilestonesRequest.post("/fetch_progress/", payload);
            const { data } = resp;
            dispatch({
                type: MILESTONES_FETCH_PROGRESS,
                payload: data
            });

            dispatch( setInstanceName(payload.instance_name || "") );
            dispatch( setInteracciones(payload.user_id) );
            resolve(true);
        } catch(err){
            dispatch({
                type: MILESTONES_RESET_PROGRESS,
            });
            reject(err);
        }
    })
}

export const resetProgressData = () => ({
    type: MILESTONES_RESET_PROGRESS
});

export const setInstanceName = (payload: string) => ({
    type: MILESTONES_SET_INSTANCE_NAME,
    payload
});

export const setInteracciones = (payload:any) => async (dispatch: any) => {
    try{
        const resp = await ContentManagerRequest.get(`/api/0.1/messenger_users/week_interaction/?user_id=${payload}`);
        dispatch({
            type: MILESTONES_SET_INTERACIONES,
            payload: resp.data.interactions
        });
    } catch(err){
        console.error(err)
    }
}
